
export const createMarkup = (text:string) => {
    return {
        __html: `${text}`
    };
};